import React, { useContext } from "react";
import styled, { ThemeContext } from "styled-components/macro";
import { SuccessIcon } from "../Icons/Icons";
import { highlightTextByQuery } from "../../util/util";

interface IDropDownModalProps {
  items: any[];
  activeItem: any;
  clickHandler: (e: any) => void;
  className?: string;
  showHighlightTextInDropdown?: boolean;
  searchQuery?: string;
}

const DropDownContainer = styled.div`
  box-shadow: 0px 6px 16px -6px ${({ theme }) => theme.shadowColor};
  display: block;
  max-height: 400px;
  overflow-y: auto;
  width: 100%;
  button {
    display: flex;
    justify-content: space-between;
    background-color: ${({ theme }) => theme.primaryBG};
    border: solid 1px ${({ theme }) => theme.secondaryBorder};
    border: none;
    width: 100%;
    white-space: nowrap;
    padding: 12px 8px;
    cursor: pointer;
    font-size: ${({ theme }) => theme.fontSizes.small};
    font-weight: ${({ theme }) => theme.fontSizes.small};
    color: ${({ theme }) => theme.primaryTextColor};
    span {
      margin-right: 5px;
    }
  }

  button:focus {
    background-color: ${({ theme }) => theme.secondaryButtonBG};
    outline: none;
    color: ${({ theme }) => theme.primaryTextColor};
  }

  button:hover {
    background-color: ${({ theme }) => theme.secondaryButtonBG};
    color: ${({ theme }) => theme.primaryTextColor};
  }

  &.list-dropdown {
    max-height: 244px;
    border: solid 1px ${({ theme }) => theme.primaryBorder};
    border-radius: 4px;
  }
`;

export const DropDownModal = ({
  items,
  activeItem,
  clickHandler,
  className = "",
  showHighlightTextInDropdown = false,
  searchQuery,
}: IDropDownModalProps) => {
  const theme = useContext(ThemeContext);

  return (
    <DropDownContainer className={className}>
      {items.map((item, index) => {
        // Generate a unique key based on the item type and index
        const key =
          typeof item === "object" && item !== null
            ? `item-${index}`
            : String(item);

        if (item === activeItem) {
          return (
            <div key={key}>
              <button data-name={item} onClick={clickHandler}>
                {item}
                <span>
                  <SuccessIcon fill={theme.brandColor} width={15} height={15} />
                </span>
              </button>
            </div>
          );
        } else {
          return (
            <div key={key}>
              <button data-name={item} onClick={clickHandler}>
                {showHighlightTextInDropdown ? (
                  <span
                    dangerouslySetInnerHTML={{
                      __html: `${highlightTextByQuery(
                        item,
                        searchQuery || ""
                      )} `,
                    }}
                  ></span>
                ) : (
                  item
                )}
              </button>
            </div>
          );
        }
      })}
    </DropDownContainer>
  );
};
